import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, LoginCallback, useOktaAuth } from '@okta/okta-react';
import { OverviewProvider } from './context/OverviewContext';
import { TasklistProvider } from './context/TasklistContext';
import { ToolSettingsProvider } from './context/ToolSettingsContext';
import { SchoolProvider } from './context/SchoolContext';
import RouteComponent from "./components/Routes";
import config from './config';
import { LinksProvider } from './context/LinksContext';
import { useSelectedStudent, SelectedStudentProvider } from './context/SelectedStudentContext';
import Vwo from '@components/Vwo/Vwo';
import CompletionCelebrationWarmup from '@/components/CompletionCelebration/CompletionCelebrationWarmup';
import { ShippingProvider } from './context/ShippingContext';

const oktaAuth = new OktaAuth(config.oidc);

// Inject SchoolProvider dynamically based on selectedStudent
const SchoolProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { selectedStudent } = useSelectedStudent();

  return (
    <SchoolProvider
      schoolId={selectedStudent?.schoolId ?? null}
      studentId={selectedStudent?.identityId ?? null}
    >
      {children}
    </SchoolProvider>
  );
};

const App: React.FC = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };
     
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const getTokenVal = urlParams.get("t");
    const canvasRedirect = urlParams.get("redirect");
    
    let canvasVal = sessionStorage.getItem("canvas");
      if (canvasRedirect && !canvasVal) {
      sessionStorage.setItem("canvas", canvasRedirect || "");
      }

    if (getTokenVal) {
      sessionStorage.setItem("authToken", getTokenVal);
        let canvasVal = sessionStorage.getItem("canvas");
        if (canvasVal) {
        navigate("/milestone-1", { replace: true });
      }
      navigate("/", { replace: true });
    } else if (canvasRedirect) {
      navigate("/milestone-1", { replace: true });
    }

  }, [navigate]);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Vwo />
      <CompletionCelebrationWarmup />
      <OverviewProvider>
        <LinksProvider>
          <SelectedStudentProvider>
            <SchoolProviderWrapper>
              <TasklistProvider>
                  <ToolSettingsProvider>
                      <ShippingProvider>
                        <RouteComponent /> 
                      </ShippingProvider>
                  </ToolSettingsProvider>
              </TasklistProvider>
            </SchoolProviderWrapper>
          </SelectedStudentProvider>
        </LinksProvider>
      </OverviewProvider>
    </Security>
  );
};

export default App;